import type { Person } from './types/person';

export const people: Person[] = [
  {
    id: 'faith-miriam',
    name: 'Faith Miriam',
    role: 'Data Scientist',
    social: {
      linkedin: 'https://www.linkedin.com/in/faith-osoro/',
    },
  },
  {
    id: 'hope-ibrahim',
    name: 'Hope Ibrahim',
    role: 'Software Engineer',
    social: {
      linkedin: 'https://www.linkedin.com/in/hope-ibrahim/',
    },
  },
  {
    id: 'moses-mutuku',
    name: 'Moses Mutuku',
    role: 'Sofware Engineer',
    social: {
      linkedin: 'https://www.linkedin.com/in/moses-mutuku-5a011915a/',
    },
  },
  {
    id: 'shimanyi-valentino',
    name: 'Shimanyi Valentino',
    role: 'Technology Advisor',
    social: {
      linkedin: 'https://www.linkedin.com/in/shimanyi',
    },
  },
  {
    id: 'michael-orina',
    name: 'Micheael Orina',
    role: 'Software Engineer',
    social: {
      linkedin: 'https://www.linkedin.com/in/michael-orina-aba567214/',
    },
  },
  {
    id: 'tonny-shimanyi',
    name: 'Tonny Shimanyi',
    role: 'Dev Apprentice',
    social: {},
  },
];

export const peopleById = Object.fromEntries(people.map((person) => [person.id, person])) as Record<
  string,
  Person
>;
